import { render, staticRenderFns } from "./MediaWireTransferRequestTable.vue?vue&type=template&id=013c23ea&scoped=true"
import script from "./MediaWireTransferRequestTable.vue?vue&type=script&lang=js"
export * from "./MediaWireTransferRequestTable.vue?vue&type=script&lang=js"
import style0 from "./MediaWireTransferRequestTable.vue?vue&type=style&index=0&id=013c23ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c23ea",
  null
  
)

export default component.exports